import ScriptHelper from "base/ScriptHelper";

export default class RecaptchaHelper {
    static load() {
        if (!RecaptchaHelper.is_loading) {
            RecaptchaHelper.is_loading = true;
            ScriptHelper.load_script("https://www.google.com/recaptcha/api.js?onload=recaptchaLoaded&render=explicit");
        }

        return RecaptchaHelper.load_promise;
    }

    static init($element) {
        RecaptchaHelper.destroy();

        let $recaptcha = $element.find(".g-recaptcha-eotw");
        grecaptcha.render($recaptcha[0], $recaptcha.data());
        $element.find(".g-recaptcha-response").remove();

        RecaptchaHelper.$recaptcha = $recaptcha;
    }

    static validate() {
        grecaptcha.reset();
        let promise = new Promise((resolve, reject) => {
            window.onRecaptchaSubmit = resolve;
            window.onRecaptchaError = reject;
            grecaptcha.execute();
        });

        RecaptchaHelper.watch_for_dismiss(promise);
        return promise;
    }

    static watch_for_dismiss(promise) {
        let id = ++RecaptchaHelper.REQUEST_ID;

        let openCheckInterval;
        let dismissCheckInterval;

        function stopCheckingForDismiss() {
            if (openCheckInterval) {
                clearInterval(openCheckInterval);
            }
            if (dismissCheckInterval) {
                clearInterval(dismissCheckInterval);
            }
        }

        let finished = false;


        promise.then(() => {
            finished = true;
            stopCheckingForDismiss();
        }, () => {
            finished = true;
            stopCheckingForDismiss();
        });

        openCheckInterval = setInterval(() => {
            if (id !== RecaptchaHelper.REQUEST_ID || finished) {
                stopCheckingForDismiss();
                return;
            }

            let $iframes = $("iframe[src*='recaptcha/api2/bframe']:not([data-captcha-request-id])");

            let visible = true;
            $iframes.parents().each((_, parent) => {
                if (parseFloat($(parent).css("opacity")) !== 1) {
                    visible = false;
                }
            });

            if ($iframes.length > 0 && visible) {
                clearInterval(openCheckInterval);
                $iframes.attr("data-captcha-request-id", id);

                // Allow the window to fade in
                setTimeout(() => {
                    dismissCheckInterval = setInterval(() => {
                        if (id !== RecaptchaHelper.REQUEST_ID || finished) {
                            stopCheckingForDismiss();
                            return;
                        }
                        let visible = true;

                        $iframes.parents().each((_, parent) => {
                            if (parseFloat($(parent).css("opacity")) === 0) {
                                visible = false;
                            }
                        });

                        if (!visible) {
                            //Dismissed
                            stopCheckingForDismiss();

                            // Set a timeout to check if it's a success
                            setTimeout(() => {
                                if (finished) {
                                    return;
                                }
                                window.onRecaptchaError(new Error("You must complete the recaptcha to continue"));
                            }, 700);
                        }
                    }, 300);
                }, 2000);
            }
        }, 300);
    }

    static destroy() {
        if (!RecaptchaHelper.$recaptcha) {
            return;
        }
        try {
            grecaptcha.reset();
        } catch (e) {
            //Noop
        }
        RecaptchaHelper.$recaptcha.remove();
        RecaptchaHelper.$recaptcha = undefined;
    }

}

RecaptchaHelper.REQUEST_ID = 0;

let load_resolve;
RecaptchaHelper.load_promise = new Promise((resolve) => load_resolve = resolve);

window.recaptchaLoaded = function () {
    load_resolve();
};
